import axiosInstance from "api/axiosInstance";

export interface Sport {
  id: number;
  name: string;
  icon_url: string;
  is_active: boolean;
}

interface SportsListResponse {
  sports: Sport[];
  count: number;
}

const BASE = "/server/buccl_main/api/v1/sports/";

export const sportsService = {
  list: () => axiosInstance.get<SportsListResponse>(BASE),
};
